/** VR-004. The server enforces the same limit; this one only shapes the field. */
export const CONFLICT_NOTES_MAX_LENGTH = 4000;

export const CONFLICT_LOG_PAGE_SIZE = 25;

export const CONFLICT_TAB_NEW = 'new';
export const CONFLICT_TAB_PREVIOUS = 'previous';
